module.exports = __webpack_public_path__ + "img/材料力学6_8_4.972a33ca.jpg";